/*
 *   Copyright (c) 2021 Youra Leangseng
 *   All rights reserved.
 */
import _ from 'lodash'
import moment from "moment";

export * from './theme'

var encrypter = require("object-encrypter");
var engine = encrypter("joonaakSecret", { ttl: true });

function formatMoney(amount, decimalCount = 2, decimal = '.', thousands = ',') {
  try {
    decimalCount = Math.abs(decimalCount);
    decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

    const negativeSign = amount < 0 ? '-' : '';

    const i = parseInt(
      (amount = Math.abs(Number(amount) || 0).toFixed(decimalCount))
    ).toString();
    const j = i.length > 3 ? i.length % 3 : 0;

    return (
      negativeSign +
      (j ? i.substr(0, j) + thousands : '') +
      i.substr(j).replace(/(\d{3})(?=\d)/g, `$1${thousands}`) +
      (decimalCount
        ? decimal +
        Math.abs(amount - i)
          .toFixed(decimalCount)
          .slice(2)
        : '')
    );
  } catch (e) {
    
  }
}

export const currency_format = (number, digit = 2) => `$ ${formatMoney(number, digit)}`;

export const currency_format_riel = (number) => `R ${formatMoney(number, 0, '', ',')}`;

export const overweight_calculate = (length, width, height, weight = 1) => {
  const dimensionalWeight =
    (parseInt(length) * parseInt(height) * parseInt(width)) / 6000;
  if (dimensionalWeight > weight) {
    return dimensionalWeight / 1000 - 1;
  }
  return weight - 1;
};

export const JOONAAK_COLOR = '#78be20';

export const pagination = {
  deliveryOrder: 20,
  merchant: 5,
  pickupRequest: 5,
  packageRequest: 5,
  inventory: 5,
  invoice: 20,
  receiver: 50,
};
export const COD_FEE = 0.005;
export const BUS_FEE = 1;

export const ASYNC_KEY = {
  IS_LOGINED: 'is_login',
  ACCESS_TOKEN: 'access_token',
  USER: 'login_user',
  PRINTER_IP: 'printerIpAddress',
  PICKUP_REQUEST_NOTIFICATION: 'pickupRequestNotification',
  PRINT_BARCODE_IP: 'PRINT_BARCODE_PD',
};



export const getLogsReason = (
  loginedUser,
  validData,
  type = "Updated",
  optional = null
) => {
  let bus = null;
  let taxi = null;
  if (optional) {
    bus = _.get(optional, "bus", null);
    taxi = _.get(optional, "taxi", null);
  }
  let reason = "";
  //Amount to receive from buyer in dollars
  if (_.get(validData, "receiveAmountDollars")) {
    reason +=
      "ReceiveAmountDollar: " + _.get(validData, "receiveAmountDollars") + ", ";
  }

  //Amount to receive from buyer in riels
  if (_.get(validData, "receiveAmountRiels")) {
    reason +=
      "ReceiveAmountRiels: " + _.get(validData, "receiveAmountRiels") + ", ";
  }

  //Amount received from buyer in dollars
  if (_.get(validData, "collectedDollar")) {
    reason +=
      "DriverCollectedDollar: " + _.get(validData, "collectedDollar") + ", ";
  }

  //Amount received from buyer in riels
  if (_.get(validData, "collectedRiel")) {
    reason +=
      "DriverCollectedRiels: " + _.get(validData, "collectedRiel") + ", ";
  }
  if (_.get(validData, "declarePrice")) {
    reason += "DeclarePrice: " + _.get(validData, "declarePrice") + ", ";
  }
  if (_.get(validData, "paymentType")) {
    reason += "PaymentType: " + _.get(validData, "paymentType") + ", ";
  }
  if (_.get(validData, "note")) {
    reason += "Note: " + _.get(validData, "note") + ", ";
  }
  if (_.get(validData, "zone")) {
    reason += "Zone: " + _.get(validData, "zone") + ", ";
  }
  if (_.get(validData, "paidTo")) {
    reason += "PaidTo: " + _.get(validData, "paidTo") + ", ";
  }
  if (_.get(validData, "recontactDate")) {
    reason +=
      " RecontactOn: " +
      moment(_.get(validData, "recontactDate")).format(dateFormatInHub) +
      ", ";
  }
  if (_.get(validData, "recontactNote")) {
    reason += "RecontactNote: " + _.get(validData, "recontactNote") + ", ";
  }
  if (_.get(validData, "expectedDeliveryDate")) {
    reason +=
      " ExpectedDeliveryDate: " +
      moment(_.get(validData, "expectedDeliveryDate")).format(dateFormatInHub) +
      " ";
  }
  if (_.get(validData, "expectedDeliveryTimeFrom")) {
    reason +=
      " From: " +
      moment(_.get(validData, "expectedDeliveryTimeFrom")).format("hh:mm A") +
      " ";
  }
  if (_.get(validData, "expectedDeliveryTimeTo")) {
    reason +=
      " To: " +
      moment(_.get(validData, "expectedDeliveryTimeTo")).format("hh:mm A") +
      ", ";
  }

  if (_.get(validData, "expectedDeliveryNote")) {
    reason +=
      " ExpectedDeliveryNote: " +
      _.get(validData, "expectedDeliveryNote") +
      ", ";
  }

  if (_.get(validData, "extraCharge")) {
    reason += " ExtraCharge: " + _.get(validData, "extraCharge") + ", ";
  }

  if (_.get(validData, "extraChargeNote")) {
    reason += " ExtraChargeNote: " + _.get(validData, "extraChargeNote") + ", ";
  }

  if (_.get(validData, "IncludePickpack")) {
    reason +=
      " IncludePickpack: " +
      (_.get(validData, "includePickpack") ? "true" : "false" + ", ");
  }

  if (_.get(validData, "isProvinceTransfer")) {
    reason += "✅ 🚧🚚🚚🚚🚧 Province transfer checked, ";
  }

  if (_.get(validData, "busOrTaxiFee")) {
    reason += "BusOrTaxiFee: " + _.get(validData, "busOrTaxiFee") + ", ";
  }

  if (bus) {
    reason +=
      "Bus info: " +
      _.get(bus, "companyName") +
      ", tel: " +
      _.get(bus, "phoneNumberPretty");
  }

  if (taxi) {
    reason +=
      "Taxi info: " +
      _.get(taxi, "driverName") +
      ", tel: " +
      _.get(taxi, "phoneNumberPretty") +
      ", plateNumber: " +
      _.get(taxi, "vehiclePlateNumber");
  }

  if (_.get(validData, "deliveredDate")) {
    reason += "DeliveredDate: " + _.get(validData, "deliveredDate") + ", ";
  }
  if (_.get(validData, "deliveredNote")) {
    reason += "DeliveredNote: " + _.get(validData, "deliveredNote") + ", ";
  }
  if (_.get(validData, "returnDate")) {
    reason += "ReturnDate: " + _.get(validData, "returnDate") + ", ";
  }
  if (_.get(validData, "returnReason")) {
    reason += "ReturnReason: " + _.get(validData, "returnReason") + ", ";
  }
  if (_.get(validData, "transferMethod")) {
    reason += "TransferMethod: " + _.get(validData, "transferMethod") + ", ";
  }
  if (_.get(validData, "transferTo")) {
    reason += "transferTo: " + _.get(validData, "transferTo") + ", ";
  }
  if (_.get(validData, "transferAmount")) {
    reason += "transferAmount: " + _.get(validData, "transferAmount") + ", ";
  }
  if (_.get(validData, "transferCode")) {
    reason += "transferCode: " + _.get(validData, "transferCode") + ", ";
  }

  if (_.get(validData, "customReason")) {
    reason += _.get(validData, "customReason");
  }

  if (_.get(validData, "isExpress")) {
    reason += "mark as express, ";
  }

  if (_.get(validData, "isTransferWithdraw")) {
    reason += "already withdraw, ";
  }

  if (_.get(validData, "provinceSelectedObject")) {
    reason += "Province: " + _.get(validData, "provinceSelectedObject.label");
  }

  if (_.get(validData, "selectedReceiverAddress")) {
    reason +=
      " Selected address: " +
      _.get(validData, "selectedReceiverAddress.connect.id") +
      ", ";
  }

  if (_.get(validData, "selectedReceiverPhoneNumber")) {
    reason +=
      " Receiver Phone: " +
      _.get(validData, "receiverPhoneNumberValue") +
      ", ";
  }

  if (_.get(validData, "receiverName")) {
    reason +=
      " Ordering name: " +
      _.get(validData, "receiverName") +
      ", ";
  }

  if (_.get(validData, "name")) {
    reason +=
      " Receiver Name: " +
      _.get(validData, "name") +
      ", ";
  }

  if (_.get(validData, "secondaryPhone")) {
    reason +=
      " Secondary name: " +
      _.get(validData, "secondaryPhone") +
      ", ";
  }

  if (_.get(validData, "isUrgent") != undefined) {
    reason +=
      " is urgent: " +
      _.get(validData, "isUrgent") +
      ", ";
  }

  if (_.get(validData, "busOrTaxiBillPhoto")) {
    reason += " Update transfer receipt,";
  }

  if (_.get(validData, "invalidNote")) {
    reason += ` Invalid Note: ${_.get(validData, "invalidNote")},`;
  }

  return reason;
};


export const config = {
  bucketName: 'joonaakasset',
  dirName: 'inventories',
  region: 'ap-southeast-1',
  accessKeyId: 'AKIAIIR5DGA3FNTO5VJQ',
  secretAccessKey: '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',
};

export const dateFormatInHub = 'Do, MM YYYY';

export const dayOptions = [
  {
    label: 'Monday',
    value: 'Monday',
  },
  {
    label: 'Tuesday',
    value: 'Tuesday',
  },
  {
    label: 'Wednesday',
    value: 'Wednesday',
  },
  {
    label: 'Thursday',
    value: 'Thursday',
  },
  {
    label: 'Friday',
    value: 'Friday',
  },
  {
    label: 'Saturday',
    value: 'Saturday',
  },
  {
    label: 'Sunday',
    value: 'Sunday',
  },
];

export const zoneOptions = [
  {
    label: 'Zone 1',
    value: '1',
  },
  {
    label: 'Zone 2',
    value: '2',
  },
  {
    label: 'Zone 3',
    value: '3',
  },
  {
    label: 'Taxi',
    value: '0',
  },
  {
    label: 'Joonaak',
    value: 'joonaak',
  },
  {
    label: 'No Zone',
    value: '',
  },
];

export const ZONE_NUMBER = {
  1: 'Zone 1',
  2: 'Zone 2',
  3: 'Zone 3',
  0: 'Taxi',
  joonaak: 'Joonaak',
  none: 'No Zone',
};

export const BLACK_LIST_PHONE = [
  '201906050500',
  '201906050505',
  '201906270400',
];

export const CONSTANTS = {
  //DATE_FORMAT: 'Do, MM YYYY',
  DATE_FORMAT: 'YYYY-MM-DD',
  DATE_FORMAT_DETAIL: 'DD, MMM YYYY hh:mm A',
  PAGE_SIZE: 25,
}

/***
 * Functions
 */
export const jnEncrypt = async obj => {
  //7 days localStorage expired
  return engine.encrypt(obj, 7 * 24 * 60 * 60 * 1000);
};

export const jnDecrypt = async encryptedObj => {
  if(encryptedObj)
  try{
    return await engine.decrypt(encryptedObj);
  }catch(e) {}
};

export const getAddressText = (addressObject, provinceObject = null) => {
  let addressText = "";
  if (provinceObject === null) {
    if (_.get(addressObject, "alias")) {
      addressText += addressObject.alias + ", ";
    }
    if (_.get(addressObject, "houseNumber")) {
      addressText += "#" + addressObject.houseNumber + ", ";
    }
    if (_.get(addressObject, "streetName")) {
      addressText += "st: " + addressObject.streetName + ", ";
    }
    if (_.get(addressObject, "streetNumber")) {
      addressText += addressObject.streetNumber + ", ";
    }
    if (_.get(addressObject, "sangkat")) {
      addressText += addressObject.sangkat + ", ";
    }
    if (_.get(addressObject, "other")) {
      addressText += addressObject.other;
    }

    return addressText;
  } else {
    return _.get(provinceObject, "name");
  }
};

export const getDeliveryTime = ({ edate, dfrom, dto }) => {
  let text = 'N/A';
  if (edate !== null) {
    text = moment(edate).format('DD/MM');
  }
  if (dfrom !== null) {
    if (text == 'N/A') {
      text = moment(dfrom).format('h:mm a');
    } else {
      text += ` ${moment(dfrom).format('h:mm a')}`;
    }
  }

  if (dto !== null) {
    text += ' - ';
    text += moment(dto).format('h:mm a');
  }
  return text;
};

export const EXCHANGE_RATE = 4000
